import * as NavActions from '../../../store/shipments/nav/shipments.nav.actions';

import * as Actions from './shipments.filtering.actions';
import * as StateHelper from './shipments.filtering.reducer-helper';
import { APP_INITIALIZATION } from '../../core/base-actions';

const initialState = {
  savedFilterViews: [],
  defaultFilterView: StateHelper.getDefaultFilterView(),
  activeFilterViewId: StateHelper.getDefaultFilterView().filterViewId,
  customFilterView: undefined,
};

export const shipmentsFilterReducer = (state = initialState, action) => {
  const { savedFilterViews, filterViewId, filterView, appliedFilters, propName, propValue, viewId } = action;
  const defaultView = StateHelper.getDefaultFilterView(viewId);
  switch (action.type) {
    case Actions.SHIPMENTS_SWITCH_FILTERVIEW: {
      return {
        ...state,
        activeFilterViewId: filterViewId,
      };
    }
    case Actions.SHIPMENTS_AUTOSWITCH_FILTERVIEW_CUSTOM: {
      const newCustomView = StateHelper.createCustomFilterView(filterView, appliedFilters);
      return {
        ...state,
        customFilterView: newCustomView,
        activeFilterViewId: newCustomView.filterViewId,
      };
    }
    case NavActions.SHIPMENTS_SEARCH: {
      return {
        ...state,
        activeFilterViewId: state.defaultFilterView.filterViewId,
        customFilterView: undefined,
      };
    }
    case Actions.SHIPMENTS_AUTOSWITCH_FILTERVIEW_DEFAULT: {
      return {
        ...state,
        activeFilterViewId: state.defaultFilterView.filterViewId,
        defaultFilterView: {
          ...state.defaultFilterView,
          appliedFilters: state.defaultFilterView?.appliedFilters?.filter((f) => f.isLocked),
        },
        customFilterView: undefined,
      };
    }
    case Actions.SHIPMENTS_CHANGE_CUSTOM_FILTERVIEW_PROP: {
      const updatedCustomView = StateHelper.updateCustomViewProp(propName, propValue, state.customFilterView);
      return {
        ...state,
        customFilterView: updatedCustomView,
      };
    }
    case Actions.SHIPMENTS_CHANGE_FILTERVIEW_PROP: {
      return {
        ...state,
        savedFilterViews: StateHelper.replaceUpdatedFilterView(propName, propValue, filterViewId, state.savedFilterViews),
      };
    }
    case APP_INITIALIZATION: {
      return {
        ...state,
        savedFilterViews: (action?.initialData?.allGridConfigs || []).filter((view) => view.gridConfigTypeId === 'shipping'),
      };
    }
    case Actions.SHIPMENTS_GET_SAVED_FILTERVIEWS_SUCCESS: {
      return {
        ...state,
        savedFilterViews: savedFilterViews.filter((view) => view.gridConfigTypeId === 'shipping'),
      };
    }
    case Actions.SHIPMENTS_SAVE_NEW_FILTERVIEW_SUCCESS:
    case Actions.SHIPMENTS_SAVE_EXISTING_FILTERVIEW_SUCCESS: {
      return {
        ...state,
        customFilterView: undefined,
        activeFilterViewId: filterView.filterViewId,
        savedFilterViews: [...state.savedFilterViews.filter((view) => view.filterViewId !== filterView.filterViewId), filterView],
      };
    }
    case Actions.SHIPMENTS_DELETE_FILTERVIEW_SUCCESS: {
      return {
        ...state,
        savedFilterViews: state.savedFilterViews.filter((savedView) => savedView.filterViewId !== filterView.filterViewId),
        activeFilterViewId: state.defaultFilterView.filterViewId,
      };
    }
    case NavActions.SHIPMENTS_CHANGE_VIEW:
      return {
        ...state,
        activeFilterViewId: defaultView.filterViewId,
        defaultFilterView: defaultView,
        customFilterView: undefined,
      };
    default:
      return state;
  }
};

export { namespace } from './shipments.filtering.reducer.metadata';
